// Timesheet arithmetic shared by the Timesheets page and its exports.
// Minutes in, formatted hours out; overtime is a weekly threshold from the
// store's accounting profile (null = no overtime split).

export const hmm = (minutes) => {
  const m = Math.max(0, Math.round(Number(minutes) || 0));
  return `${Math.floor(m / 60)}:${String(m % 60).padStart(2, '0')}`;
};
export const decimalHours = (minutes) => Math.round((Number(minutes) || 0) / 60 * 100) / 100;

// POS hourlyWage is cents; the data has garbage rows (memory: values up to
// $8B/h), so anything above this is flagged rather than multiplied.
export const WAGE_CAP_CENTS = 20000;
export const wageSuspicious = (wageCents) => wageCents !== null && wageCents !== undefined && wageCents > WAGE_CAP_CENTS;
export const payCents = (minutes, wageCents) => Math.round((Number(minutes) || 0) / 60 * (Number(wageCents) || 0));

// ISO Monday of the week containing the date (weeks run Mon–Sun).
export function weekStart(dateISO) {
  const d = new Date(dateISO + 'T00:00:00Z');
  const dow = (d.getUTCDay() + 6) % 7; // 0 = Monday
  d.setUTCDate(d.getUTCDate() - dow);
  return d.toISOString().slice(0, 10);
}

// Split an employee's shifts into regular and overtime minutes, week by
// week, against a weekly threshold in hours (null → everything regular).
export function splitOvertime(shifts, thresholdHours) {
  const total = shifts.reduce((a, s) => a + (s.minutes || 0), 0);
  if (!thresholdHours) return { reg: total, ot: 0 };
  const weeks = new Map();
  for (const s of shifts) {
    const k = weekStart(s.date);
    weeks.set(k, (weeks.get(k) || 0) + (s.minutes || 0));
  }
  let ot = 0;
  for (const mins of weeks.values()) ot += Math.max(0, mins - thresholdHours * 60);
  return { reg: total - ot, ot };
}
